import { useAtomValue } from "jotai";
import { lazy, Suspense, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/Button";
import { Sheet, SheetContent, SheetTrigger } from "../components/Sheet";
import { VITE_POLICY_URL, VITE_TOS_URL } from "../lib/constants";
import { isInOauthFlow } from "../store/other";
import { userIdentifyAtom } from "../store/user";

// Lazy load TermsOfService component
const TermsOfService = lazy(() => import("../components/TermsOfService"));

export default function Home() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userIdentify = useAtomValue(userIdentifyAtom);
  useEffect(() => {
    if (isInOauthFlow()) {
      return;
    }
    // 避免在verify-go-back页面进行自动重定向
    if (userIdentify?.user && userIdentify.review.status === 'approved' && !location.pathname.includes("/verify-go-back")) {
      navigate("/user");
    }
  }, [userIdentify, navigate]);

  return (
    <div className="w-full h-full flex flex-col max-h-dvh justify-end overflow-hidden">
      <img src="/img/home/bg.png" className="absolute w-full top-0" />
      <div className="absolute  w-full h-[400px] top-0 bg-gradient-to-b from-black/50 to-black/0" />
      <img
        src="/svg/logo-very.svg"
        className="absolute top-10 left-3"
      />

      <div className="w-full z-10  bg-background rounded-tl-[20px] rounded-tr-[20px] flex-col justify-end items-start px-4 pt-12 pb-6">
        <div className="text-4xl font-medium text-muted text-center">
          The First-Ever
        </div>
        <div className="text-4xl font-medium text-default text-center">
          Proof of Reality
        </div>
        <div className="self-stretch flex flex-col justify-start items-start gap-3 mt-10">
          <Sheet>
            <SheetTrigger className="w-full">
              <Button>
                {t("common.getStarted")}
                <img src="/img/home/arrow-right.svg" />
              </Button>
            </SheetTrigger>

            <SheetContent>
              <Suspense
                fallback={
                  <div className="p-4 text-center">{t("common.loading")}</div>
                }
              >
                <TermsOfService />
              </Suspense>
            </SheetContent>
          </Sheet>

          <Button
            type="secondary"
            onClick={() => navigate("/email?login=true")}
          >
            {t("common.signIn")}
          </Button>

          <div className="flex-1 justify-start text-muted text-xs font-medium text-start mb-4">
            {t("home.termsAgreement")}
            <span
              className="underline px-1"
              onClick={() => window.open(VITE_TOS_URL, "_blank")}
            >
              {t("home.termsOfService")}
            </span>
            {t("home.and")}
            <span
              className="underline px-1"
              onClick={() => window.open(VITE_POLICY_URL, "_blank")}
            >
              {t("home.privacyPolicy")}.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
